import { Route, Switch, useLocation } from "wouter";
import { useEffect } from "react";
import CreateNewEmployee from "./Components/EmployeeInformation/CreateNewEmployee";
import EmployeeRecords from "./Components/EmployeeInformation/EmployeeRecords";

function App() {
  const [location] = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth", // or "smooth"
    });
  }, [location]);
  return (
    <Switch>
      {/* Public Route */}
      <Route path="/" component={CreateNewEmployee} />
      <Route path="/employee-records" component={EmployeeRecords} />
    </Switch>
  );
}

export default App;
